export class ConnectSourceAwsOrganizationalUnitResponse {
    'organizationalUnit';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "SourceAwsOrganizationalUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectSourceAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
